export default __webpack_public_path__ + "static/coudiere.mobile.inspirations-9eb371a9625651931ca3959acd8d08b5.jpg";